import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./i18n";
import { Provider } from "react-redux";
import store from "./store/index";
import Routes from "./routes/index";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <Suspense fallback={null}>
    <Provider store={store}>
      <Routes />
    </Provider>
  </Suspense>,

  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
